import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const PurchaseIntroFastProvider = lazyWithPreload(
  () => import('./PurchaseIntroFastProvider'),
)
